// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__UOBt9","title":"Modal_title__Mqo6X","description":"Modal_description__ZNxbT"};